import axios, {
  AxiosResponse,
  AxiosRequestConfig,
  AxiosError,
  AxiosTransformer
} from 'axios'
import qs from 'qs'
import { logout } from '@/service/session/auth'
import { getAuthorizationHeader } from '@/service/session/token'
import { AsyncChainFn } from '@/models/helpers/function'

const requestInterceptor: AsyncChainFn<AxiosRequestConfig> = async request => ({
  ...request,
  headers: {
    ...request.headers,
    ...(await getAuthorizationHeader())
  }
})

const requestErrorInterceptor = (error: any) => Promise.reject(error)

const responseInterceptor = (response: AxiosResponse) => response

const responseErrorInterceptor = (error: AxiosError) => {
  const res = error.response
  if (res) {
    switch (res.status) {
      case 400:
      case 412:
        error.message = res.data.Error
        break
      case 401: // unauthorized
        error.message = '登录失效，请重新登录'
        logout()
        break
      case 500: // 服务器内部错误
      case 502: // Bad Gateway
      case 504: // Gateway Time-out
      case 505: // HTTP Version not supported
        error.message = '服务器未响应，请联系管理员'
        break
      case 503: // 服务器繁忙
        error.message = '服务器繁忙，请重试'
        break
      case 501: // 请求方法不支持
      default:
        error.message = '系统异常，请联系管理员'
        break
    }
  } else if (error.message === 'Network Error') {
    error.message = '请检查网络连接是否正常'
  }
  return Promise.reject(error)
}

const transformRequest: AxiosTransformer = (data, headers) => {
  const contentType = headers['Content-Type']
  if (typeof contentType !== 'string') return data

  const lower = contentType.toLocaleLowerCase()
  if (lower.includes('multipart/form-data')) return data
  if (lower.includes('application/json')) return JSON.stringify(data)
  return qs.stringify(data)
}

// Full config:  https://github.com/axios/axios#request-config
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 600 * 1000,
  headers: { 'Content-Type': 'application/json' }
})

service.interceptors.request.use(requestInterceptor, requestErrorInterceptor)
service.interceptors.response.use(responseInterceptor, responseErrorInterceptor)
service.defaults.transformRequest = transformRequest
export const post = service.post
export const get = service.get
export const del = service.delete
export const put = service.put
export { service as axios }
